var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_vm._v("\n\t"+_vm._s(_vm.message)+"\n\t"),_c('button',{staticClass:"button close",on:{"click":function($event){return _vm.$emit('close')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }